import styled from '@emotion/styled';
import { colorToAlpha } from 'helpers/insight';
import { InsightType } from 'utils/entities';
import { H3 } from 'ds/components/typography';

export const Wrapper = styled.div `
  width: 100%;
  background: ${({ theme }) => theme.colors.neutrals.white};
  padding: 0;
  position: relative;

  ${({ theme }) => theme.media.showAt({ to: 2 }) `
    box-shadow: ${theme.shadow.level3};
    padding: 8px 24px 8px;
    border: 1px solid ${theme.colors.neutrals.grey8};
    border-radius: ${theme.borderRadius.tiny};
  `}
`;

export const SectionsWrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 3 }) `
    &:after {
      position: absolute;
      content: '';
      ${theme.isRTL ? 'right' : 'left'}: 0;
      top: 0;
      bottom: 0;
      width: 6px;
      background: ${colorToAlpha(theme.colors.insights.planning, 0.2)};
      border-top-${theme.isRTL ? 'right' : 'left'}-radius: ${theme.borderRadius.tiny};
      border-bottom-${theme.isRTL ? 'right' : 'left'}-radius: ${theme.borderRadius.tiny};
    }
    & > div:not(:last-of-type) > div:last-of-type {
      border-bottom: 1px solid ${theme.colors.neutrals.grey9};
    }
    border: 1px solid ${theme.colors.neutrals.grey8};
    border-radius: ${theme.borderRadius.tiny};
  `}
`;

export const CategorySectionWrapper = styled.section`
  &:not(:last-of-type) {
    position: relative;
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      ${({ theme }) => theme.isRTL ? 'right' : 'left'}: 6px;
      ${({ theme }) => theme.isRTL ? 'left' : 'right'}: 0px;
      height: 1px;
      background: ${({ theme }) => theme.colors.neutrals.grey9};
    }
  }
`;

export const CategorySectionStyled = styled.article `
  ${({ theme }) => theme.media.showAt({ to: 2 }) `
    & + & {
      padding-top: 16px;
    }
  `}
`;

export const NewConstructionWrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 3 }) `
    padding: ${theme.isRTL ? '16px 48px 16px 8px' : '16px 8px 16px 48px'};
    position: relative;
    &:not(:first-of-type) {
      &:before {
        position: absolute;
        content: '';
        display: block;
        flex-basis: 100%;
        top: 0;
        ${theme.isRTL ? 'right' : 'left'}: 48px;
        ${theme.isRTL ? 'left' : 'right'}: 32px;
        height: 1px;
        background: ${theme.colors.neutrals.grey8};
      }
    }
  `}
`;

export const CategoryTitleStyled = styled.header `
  padding: 16px 0;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.insights[InsightType.Planning]};

  > svg {
    ${({ theme }) => theme.isRTL ? 'margin-left' : 'margin-right'}: 8px;
    > path {
      fill: ${({ theme }) => theme.colors.insights[InsightType.Planning]};
    }
  }

  > h4 {
    line-height: 1;
  }

  ${({ theme }) => theme.media.showAt({ from: 3 }) `
    padding: 16px 24px;
  `}
`;

export const CategoryTitleColumnsStyled = styled.div `
  display: flex;
  align-items: center;

  h4 + h4 {
    color: ${({ theme }) => theme.colors.neutrals.grey3};
    margin-left: 8px;
  }

  ${({ theme }) => theme.media.showAt({ to: 2 }) `
    display: block;

    h4 + h4 {
      margin-left: 0;
    }
  `};
`;

export const ConstructionItemWrapper = styled.div`
  height: 88px;
  overflow: hidden;
  ${({ theme }) => theme.media.showAt({ from: 3 }) `
    overflow: visible;
    height: auto;
    display: flex;
    flex-wrap: wrap;
  `}
`;

export const LocationTextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  ${({ theme }) => theme.media.showAt({ to: 2 }) `flex: 1` };
  ${({ theme }) => theme.media.showAt({ from: 3 }) `
    width: 132px;
    margin-${theme.isRTL ? 'left' : 'right'}: 24px;
  `}

  > svg {
    margin: 0 12px;
    > path {
      fill: ${({ theme }) => theme.colors.neutrals.grey5};
    }
  }
`;

export const CollapsibleBlock = styled.div ``;

export const ConstructionListWrapper = styled.div `
  display: inline-flex;
  align-items: center;
  margin-top: 16px;

  color: ${({ theme }) => theme.colors.neutrals.grey3};
  ${({ theme }) => theme.media.showAt({ from: 3 }) `margin-top: 8px`};
  ${({ theme }) => theme.isRTL ? 'margin-left' : 'margin-right'}: 16px;
  > svg {
    ${({ theme }) =>  theme.isRTL ? 'margin-left' : 'margin-right' }: 8px;
    > path {
      fill: ${({ theme }) => theme.colors.neutrals.grey3};
    }
  }
`;

export const EstablishmentEndWrapper = styled.div `
  position: relative;
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.neutrals.grey3};
  > svg {
    ${({ theme }) => theme.isRTL ? 'margin-left' : 'margin-right'}: 8px;
    > path {
      fill: ${({ theme }) => theme.colors.neutrals.grey3};
    }
  }

  ${({ theme }) => theme.media.showAt({ from: 3 }) `
    margin-top: 8px;
  `}
`;


export const TimeLineWrapper = styled.div `
  display: flex;
  position: relative;
  flex-direction: column;
  margin-top: 16px;
  ${({ theme }) => theme.media.showAt({ from: 3 }) `
    margin-top: 26px;
    flex-direction: row;
  `}
`;

interface ITimeLineItem {
  isPastItem: boolean;
}

export const TimeLineItem = styled.div<ITimeLineItem> `
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  ${({ theme }) => theme.isRTL ? 'padding-right' : 'padding-left'  }: 37px;
  ${({ theme }) => theme.media.showAt({ from: 3 }) `
    padding: 18px 0 0 0;
    width: 95px;
  `}

  > div:first-of-type {
    color: ${({ theme }) => theme.colors.neutrals.grey1};
  }

  > div:last-of-type {
    color: ${({ theme }) => theme.colors.neutrals.grey4};
  }
  > svg {
    position: absolute;
    top: calc(50% - 8px);
    ${({ theme }) => theme.isRTL ? 'right' : 'left'}: 0;
    > path {
      fill: ${({ theme }) =>  theme.colors.insights[InsightType.Planning]};
    }
    ${({ theme }) => theme.media.showAt({ from : 3 }) `
      top: 0;
    `}
  }

  ${({ isPastItem, theme }) => `
    &:not(:first-of-type):after {
      content: '';
      position: absolute;
      width: 33px;
      height: 10px;
      top: -13px;
      background-image: radial-gradient(circle,
       ${isPastItem
         ? theme.colors.insights[InsightType.Planning]
         : theme.colors.neutrals.grey8},

       ${isPastItem
         ? theme.colors.insights[InsightType.Planning]
         : theme.colors.neutrals.grey8},

       ${theme.colors.neutrals.white} 2px,
       ${theme.colors.neutrals.white}
      );
      background-size: 8px 10px;
      transform: rotate(270deg);
      ${theme.isRTL ? 'right' : 'left' }: -9px;
    }
  `}

  ${({ theme }) => theme.media.showAt({ from: 3 }) `
     &:not(:first-of-type):after {
       transform: none;
       left: unset;
       width: 75px;
       top: 3px;
       ${theme.isRTL
          ? 'left: calc(100% + 3px); right: unset;'
          : 'right: calc(100% + 3px); left: unset;'
        }
     }
  `}

  ${({ isPastItem, theme }) =>  !isPastItem && `
    > svg {
      display: none;
    }

    &:before {
      content: '';
      position: absolute;
      top: calc(50% - 8px);
      ${theme.isRTL ? 'right' : 'left'}: 0;
      width: 12px;
      height: 12px;
      border: 2px solid ${theme.colors.neutrals.grey6};
      border-radius: ${theme.borderRadius.round};
    };
  `}

  ${({ theme }) => theme.media.showAt({ from: 3 }) `
      &:before {
        top: 0;
      }
    `}
`;

export const AdditionalItemsButton = styled.div `
  padding: ${({ theme }) => theme.isRTL ? '16px 48px 16px 8px' : '16px 8px 16px 48px' };
  color: ${({ theme }) => theme.colors.insights[InsightType.Planning]};
`;

export const ConstructionDescription = styled.div `
  flex: 3;
  color: ${({ theme }) => theme.colors.neutrals.grey1 };
  ${({ theme }) => theme.media.showAt({ from: 3 }) `
    & > div:first-of-type {
      padding-${theme.isRTL ? 'left' : 'right'}: 24px;
    }
  `}
`;

export const NoConstructionsWrapper = styled.div`
  padding: 16px 32px 16px 16px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => colorToAlpha(theme.colors.insights[InsightType.Planning], 0.06)};
  border-radius: ${({ theme }) => theme.borderRadius.tiny};
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    margin: 0;
    padding: 24px 0;
    flex-wrap: wrap;
    background-color: transparent;
  `};
`;

export const NoConstructionsIconWrapper = styled.div`
  margin-${({ theme }) => theme.isRTL ? 'left' : 'right'}: 16px;

  svg {
    ${({ theme }) => theme.media.showAt({ to: 2 })`
      width: 24px;
      height: 24px;
    `};
    path {
      fill: ${({ theme }) => theme.colors.insights[InsightType.Planning]}
    }
  }
`;

export const NoConstructionsHeader = styled(H3)`
  color: ${({ theme }) => theme.colors.insights[InsightType.Planning]};
`;

export const NoConstructionsText = styled(H3)`
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    margin-top: 16px;
    width: 100%;
  `};
`;
